export enum ProjectAssetEnum {
    TIMELAPSE = 'TIMELAPSE',
    CAMERA_CCTV = 'CAMERA_CCTV',
    DRONE_FOOTAGE = 'DRONE_FOOTAGE',
    CAMERA_360 = 'CAMERA_360',
    SITE_GALLERY = 'SITE_GALLERY',
    EQUIPMENT_TRACKERS = 'EQUIPMENT_TRACKERS',
}
